export function waitForFonts() {
  if (document.fonts && document.fonts.ready) {
    return document.fonts.ready;
  }

  return new Promise((resolve) => {
    const timeout = setTimeout(() => {
      resolve();
    }, 3000);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        clearTimeout(timeout);
        resolve();
      }).catch(() => {
        clearTimeout(timeout);
        resolve();
      });
    } else {
      if (document.readyState === 'complete') {
        setTimeout(() => {
          clearTimeout(timeout);
          resolve();
        }, 100);
      } else {
        window.addEventListener('load', () => {
          setTimeout(() => {
            clearTimeout(timeout);
            resolve();
          }, 100);
        });
      }
    }
  });
}

export function areFontsLoaded() {
  if (!document.fonts) {
    return false;
  }

  const authorFonts = [
    'Raleway',
    'Fraunces',
  ];

  try {
    return authorFonts.every(fontFamily =>
      document.fonts.check(`16px ${fontFamily}`)
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error checking if fonts are loaded', error);
    return false;
  }
}

